<template>
  <div>
    <div
      v-for="(list,key) in summaryList.DetailList"
      :key="key"
      :name="key+''"
      style="width: 100%;margin-top: 15px;"
    >
      <!--<el-row>
        <el-col :span="3">
          <div style="margin-top:0px;">
            <span style="font-size: 16px;">&nbsp;总结内容</span>
            <br />
            <br />
            <el-button
              type="primary"
              class="myBtn"
              size="small"
              icon="el-icon-download"
              :disabled="isComplete"
              @click="knowledgeDialogVisible = true"
            >知识条目</el-button>
            <br />
            <br />
            <el-button
              type="success"
              class="myBtn"
              size="small"
              icon="el-icon-download"
              :disabled="isComplete"
              @click="workDialogVisible = true"
            >工作记录</el-button>
            <br />
            <br />
          </div>
        </el-col>
        <el-col :span="21">
          <div style="margin-right:0px ;">
            <WangEdit
              :initHeight="initHeight"
              :ref="'wangEdit'+key"
              @contentChanged="getEditChanged"
              :initContent="initRichEditContent"
            ></WangEdit>
            <el-row type="flex">
              <el-col :span="8">
                <el-button
                  size="small"
                  :disabled="isComplete"
                  @click="captureStart"
                  type="primary"
                >截图</el-button>
                <el-checkbox v-model="hideWindow" :disabled="isComplete">隐藏当前窗口</el-checkbox>
              </el-col>
              <el-col :span="12" style="height: 40px; overflow:hidden;">
                <el-form-item label-width="100px">
                  <div style="display:inline-block;" id="CreateTaskFilePicker">上传附件</div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-checkbox
                  v-model="SAVEKMS"
                  @change="SAVEKMSChange"
                  style="float: right;margin-top: 5px;"
                  :disabled="isComplete"
                >保存至知识库</el-checkbox>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="21" :offset="3">
          <div class="file-panel" :style="filePanelHeight" v-show="fileList.length>0">
            <div style="font-size: 14px">文件列表</div>
            <div class="file-list" :style="filePanelHeight">
              <ul
                class="file-item"
                :class="`file-${file.id}`"
                v-for="(file, index) in fileList"
                :key="index"
              >
                <li class="file-type" :icon="fileCategory(file.ext)"></li>
                <li class="file-name">
                  <div class="fileName">{{file.name}}</div>
                </li>
                <li class="file-size">{{fileSize(file.size)}}</li>
                <li class="file-status">上传中...</li>
                <li class="file-operate">
                  <a title="移除" @click="remove(file)">
                    <i class="el-icon-delete"></i>
                  </a>
                </li>
                <li class="progress"></li>
              </ul>
              <div class="no-file" v-if="!fileList.length">
                <i class="el-icon-files"></i> 暂无待上传文件
              </div>
            </div>
            <vue-upload
              ref="uploader"
              uploadButton="#CreateTaskFilePicker"
              multiple
              :formData="fileFormData"
              @fileChange="fileChange"
              @progress="onProgress"
              @success="fileUploadCompleted"
            ></vue-upload>
          </div>
        </el-col>
      </el-row>-->
       <el-row>
                    <el-col :span="24">
                        <div class="el-form-item__label" style="width: 100px;">
                            内容描述
                            <br />
                            <br />
                            <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="knowledgeDialogVisible = true">知识条目</el-button>
                            <br />
                            <br />
                            <el-button class="myBtn" size="small" icon="el-icon-download" type="success" plain @click="workDialogVisible = true">工作记录</el-button>
                        </div>
                        <div class="el-form-item__content" style="margin-left: 100px;">
                            <ayb-vueUpload :fileList="fileList" @getValue="fileGetValue" @delValue="fileDelValue" :ref="'vueUpload'+key">
                                <ayb-uploaderDrop>
                                  <!--<WangEdit
                                    :initHeight="initHeight"
                                    :ref="'wangEdit'+key"
                                    @contentChanged="getEditChanged"
                                    v-model="initRichEditContent"
                                    :initContent=""
                                  ></WangEdit>-->
                                    <wangeditor :ref="'wangEdit'+key" v-model="initRichEditContent" @change="getEditChanged" @uploader="uploader"></wangeditor>
                                    <el-row type="flex">
                                        <el-col :span="8">
                                                <el-button size="mini" @click="captureStart" style="margin-right:10px" type="primary">截图</el-button>
                                                <el-checkbox size="mini" v-model="hideWindow">隐藏当前窗口</el-checkbox>
                                        </el-col>
                                        <el-col :span="12" style="display:flex;align-items: baseline;margin-top:5px">
                                            <el-button @click="upload" class="el-button--mini" type="warning">上传附件</el-button>
                                            
                                        </el-col>
                                        <el-col :span="4">
                                         <el-checkbox
                                            v-model="SAVEKMS"
                                            @change="SAVEKMSChange"
                                            style="float: right;margin-top: 5px;"
                                            :disabled="isComplete"
                                          >保存至知识库</el-checkbox>
                                        </el-col>
                                    </el-row>
                                </ayb-uploaderDrop>
                            </ayb-vueUpload>
                        </div>
                    </el-col>
                </el-row>
    </div>
    <el-dialog
      title="知识库"
      :visible.sync="knowledgeDialogVisible"
      :before-close="knowledgeHandleClose"
      width="800px"
      center
      append-to-body
    >
      <div style="height: 430px;">
        <el-row>
          <KnowledgeSearchExpand ref="searchDetail"></KnowledgeSearchExpand>
        </el-row>
        <el-row class="is-justify-center el-row--flex">
          <el-col :span="18">
            <div style="box-sizing:border-box;width:100%;">
              <el-input placeholder="请输入综合搜索内容" v-model="txtSearch" @keyup.13.native="btnDoSearch"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button
              style="margin-left:20px"
              type="primary"
              icon="el-icon-search"
              title="搜索"
              @click="SearchKnowledge"
            >搜索</el-button>
          </el-col>
        </el-row>
        <el-row :span="24" class="tablePanel">
          <el-table
            :data="tableData"
            ref="knowledgeTable"
            border
            style="width: 100%;"
            highlight-current-row
            class="tableKeyword"
            @current-change="handleCurrentChange"
            @selection-change="changeFun"
            @row-dblclick="showKnowledgeDetail"
            height="260px"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="INSTANCE" label="ID编号" width="95" sortable></el-table-column>
            <el-table-column
              prop="TITLE"
              label="标题"
              width="360"
              :show-overflow-tooltip="true"
              sortable
            ></el-table-column>
            <el-table-column
              prop="TagNames"
              label="关键词"
              width="120"
              :show-overflow-tooltip="true"
              sortable
            ></el-table-column>
            <el-table-column
              prop="KNOWLEDGETYPENAME"
              label="知识类型"
              width="120"
              :show-overflow-tooltip="true"
              sortable
            ></el-table-column>
            <el-table-column
              prop="KNOWLEDGECLASSNAME"
              label="知识分类"
              width="120"
              :show-overflow-tooltip="true"
              sortable
            ></el-table-column>
            <el-table-column
              prop="CREATETIME"
              label="创建时间"
              width="170"
              :show-overflow-tooltip="true"
              sortable
              :formatter="timeFormatter"
            ></el-table-column>
            <el-table-column prop="AUTHORNAME" label="作者" width="120" sortable></el-table-column>
            <el-table-column
              prop="SOURCE"
              label="来源"
              width="100"
              :show-overflow-tooltip="true"
              sortable
              :formatter="sourceFormatter"
            ></el-table-column>
          </el-table>
        </el-row>
        <el-row :span="24" class="pagePanel">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :current-page="currentPage"
            :page-sizes="pageSizesArr"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="knowledgeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureKnowledgeDia">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="工作记录"
      :visible.sync="workDialogVisible"
      :before-close="workHandleClose"
      width="800px"
      center
      append-to-body
    >
      <el-form :model="workForm" class="demo-form-inline">
        <el-form-item label="名称/编号">
          <el-col :span="17">
            <el-input v-model="workForm.input" placeholder="请输入名称/编号"></el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="2">
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <el-scrollbar style="height: 100%;">
        <div style="height: 400px;">
          <el-row v-for="(c,index) in works" :key="index" style="margin-top: 3px;">
            <el-col :span="24">
              <el-card :body-style="{ padding: '0px'}" shadow="hover">
                <div style="padding: 14px;">
                  <div>
                    <span v-html="delHtmlTag(c.INFO)"></span>
                    <div class="bottom clearfix">
                      <table style="width:100%;">
                        <tr>
                          <td>
                            <time class="time">
                              <!--时间：
                              {{c.CREATETIME|timeFormater}}
                              &nbsp;&nbsp;|&nbsp;&nbsp;-->
                              创建人：
                              {{c.CREATEUSERNAME}}
                            </time>
                          </td>
                          <td style="width:90px;line-height:30px">
                            <el-button
                              type="text"
                              class="button"
                              style="color:#6aca5d"
                              @click="sureWork(c.INFO)"
                            >选中</el-button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="workDialogVisible = false">取 消</el-button>-->
        <el-button type="primary" @click="workDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <KnowledgeView ref="refknowledgeDetail" :knowledgeData="knowledgeDetail" :showComment="false"></KnowledgeView>
    <commonSelectComponent
      ref="KnowledgeSel"
      v-show="display"
      :myOption="optionSelKnowledgeObj"
      :myData="dataSelKnowledgeObj"
      @getValue="SelKnowledgeObjGetValue"
      @setValue="SelKnowledgeObjSetValue"
    ></commonSelectComponent>
    <commonOftenSelect
      ref="BSMVSel"
      v-show="display"
      :myOption="optionSelObjBSMV"
      :myData="dataSelObjBSMV"
      @getValue="SelObjBSMVGetValue"
      @setValue="SelObjBSMVSetValue"
      @setOftenUseValue="setOftenBSMV"
    ></commonOftenSelect>
  </div>
</template>

<script>
import { listToTree } from "@/api/modules/basicData/commonData";
import {
  GetAllObjTypeBSMV,
  GetAllGeneralSelTreeEx,
  GetCommonAndUsedObjTypeBSMV,
  GetKnowledgeByParam
} from "@/api/modules/basicData/knowledge";
import {
  getTaskSummaryByUserId,
  getAllTaskSummaryByTaskId,
  GetAllRecordsByUserID,
  UploadFiles,
  GetFileInfoByTaskId,
  MergeFile
} from "@/api/modules/basicData/task.js";
import { Linq, DateFormat, TimeFormat } from "@/util/common";
import { getToken } from "@/util/auth";
import WangEdit from "@/views/knowledgeBase/WangEdit.vue";
import wangeditor from "@/components/common/editor.vue";
import commonSelectComponent from "@/components/basicData/commonSelectComponent";
import commonOftenSelect from "@/components/basicData/commonOftenSelectComponent.vue";
import KnowledgeSearchExpand from "@/views/knowledgeBase/KnowledgeSearchExpand";
import KnowledgeView from "@/views/knowledgeBase/KnowledgeView";
import cap from "@/capturn/capturnwrapper.js";
import uploadFiles from "@/components/basicData/uploadFiles.vue";
export default {
  name: "sunmmaryTask",
  components: {
    wangeditor,
    commonSelectComponent,
    commonOftenSelect,
    KnowledgeSearchExpand,
    KnowledgeView,
    uploadFiles,
  },
  data() {
    return {
      SAVEKMS: false,
      onClear: 0,
      fileList: [],
      filePathList: [],
      filePanelHeight: {
        height: "60px"
      },
      fileFormData: {
        guid: this.Guid()
      },
      workForm: {
        input: ""
      },
      isComplete: false,
      knowledgeDialogVisible: false,
      workDialogVisible: false,
      hideWindow: true,
      editorContent: this.initContent,
      works: [],
      currentUser: {}, //当前登录人员
      txtSearch: "",
      initRichEditContent: "",
      tabPosition: "right",
      pageSizesArr: [2, 5, 10, 20, 30, 50, 100, 300],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      knowledgeSelData: [],
      editableTabsValue: "0",
      currentRow: null,
      searchIconState: "el-icon-arrow-down",
      showDialog: false,
      editDataObj: null,
      knowledgeDetail: {
        TITLE: ""
      },
      editor: null,
      initHeight: "150px",
      display: false,
      dataSelKnowledgeObj: {
        idArray: [],
        imageType: [],
        checkField: {
          Id: "Id",
          Pid: "Pid",
          Key: "AggrID",
          Type: "Type",
          TypeValue: [
            20,
            31,
            21,
            22,
            23,
            41,
            43,
            45,
            47,
            49,
            24,
            25,
            29,
            12,
            14,
            16,
            33,
            35,
            37,
            39
          ],
          ValidField: ["Name", "Ips", "PY", "FullPY"],
          ShowField: "Name",
          ShowFieldName: "对象实例",
          FiledList: ["Ips"]
        }
      },
      optionSelKnowledgeObj: {
        commomShowPlaceholder: "",
        commonDialogTitle: "选择对象实例",
        commonCheckedDescription: "对象实例",
        isRadio: false,
        setWidth: "100%",
        searchContainsSubsets: true, //搜索后是否包含子级
        isStrictly: true //父子节点不关联
      },
      dataSelObjBSMV: {
        idArray: [],
        imageType: [
          {
            type: 1,
            imgPath: require("@/assets/img/BSMV/类型.png")
          },
          {
            type: 2,
            imgPath: require("@/assets/img/BSMV/类型.png")
          },
          {
            type: 3,
            imgPath: require("@/assets/img/BSMV/类型.png")
          },
          {
            type: 4,
            imgPath: require("@/assets/img/BSMV/类型.png")
          },
          {
            type: 5,
            imgPath: require("@/assets/img/BSMV/类型.png")
          },
          {
            type: 6,
            imgPath: require("@/assets/img/BSMV/厂商.png")
          },
          {
            type: 7,
            imgPath: require("@/assets/img/BSMV/系列.png")
          },
          {
            type: 8,
            imgPath: require("@/assets/img/BSMV/型号.png")
          },
          {
            type: 9,
            imgPath: require("@/assets/img/BSMV/版本号.png")
          }
        ],
        checkField: {
          Id: "Id",
          Pid: "Pid",
          Key: "AggrID", //该字段前端构建，特殊处理
          Type: "Type",
          TypeValue: [1, 2, 3, 4, 5, 6, 7, 8, 9],
          ValidField: ["Name", "PY", "FullPY"],
          ShowField: "Name",
          ShowFieldName: "产品对象"
        }
      },
      optionSelObjBSMV: {
        commomShowPlaceholder: "",
        commonDialogTitle: "选择产品对象",
        commonCheckedDescription: "产品对象",
        isRadio: false,
        setWidth: "100%",
        searchContainsSubsets: true, //搜索后是否包含子级
        isStrictly: true //父子节点不关联
      },
      detailList: [
        {
          index: "1"
        }
      ],
      myTaskCode: "",
      myTaskName: "",
      myTaskDescreption: "",
      myTaskId: "",
      myUserId: "",
      myTaskState: "",
      summaryList: {
        ID: "",
        TASKID: "",
        CREATEUSERID: "",
        CREATEUSERNAME: "",
        CREATEDEPTID: "",
        CREATEDEPTNAME: "",
        CREATETIME: "",
        ISCOMPLETED: false,
        DetailList: [
          {
            ID: "",
            SUMMARYID: "",
            TITLE: "",
            CONTENT: "",
            DESCRIPTION: "",
            SAVEKMS: false,
            DeviceList: [],
            OPobjectList: []
          }
        ]
      },
      FileLists: [
        {
          FileList: []
        }
      ],
      newFileLists: [
        {
          FileList: []
        }
      ]
    };
  },
  props: {
    //设置项
    myRowData: {
      type: Object,
      default: function() {
        return {
          userId: "",
          taskId: "",
          taskState: 1,
          Complete: false,
          taskName: "",
          taskDescreption: ""
        };
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.SearchKnowledge();
    //this.currentUser = getToken();
  },
  watch: {
    onClear(val) {
      console.log("onClear", val);
      if (val === 1) {
        this.fileList = [];
        this.filePathList = [];
        this.initRichEditContent = "";
        let key = "wangEdit" + 0;
        this.$refs[key][0].setContent("");
        let vueUpload = "vueUpload" + 0;
        this.$refs[vueUpload][0].close()
        this.onClear = 0;
      }
    },
    myRowData: {
      handler(val, oldVal) {
        this.myTaskName = val.taskName;
        this.myTaskDescreption = val.taskDescreption;
        this.myTaskId = val.taskId;
        this.myUserId = val.userId;
        this.myTaskState = val.taskState;
        this.isComplete = val.Complete;
        this.getTaskDetail();
      },
      deep: true //深度监听
    },
    pageSize() {
      this.SearchKnowledge();
    },
    currentPage() {
      this.SearchKnowledge();
    },
    editableTabsValue: function(val, oldVal) {
      let key = "wangEdit" + parseInt(val);
      if (this.summaryList.DetailList[parseInt(val)].CONTENT != "") {
        this.$refs[key][0].setContent(
          this.summaryList.DetailList[parseInt(val)].CONTENT
        );
      }
    }
  },
  created() {
    cap.Init(this);
    this.toSetRowData();
  },
  methods: {
    upload() {
      let key = "vueUpload" + 0;
        // this.$refs[key][0].setContent("");
       this.$refs[key][0].openUploader({
          // id: "1111" // 传入的参数
      })
    },
    uploader(files){
      let key = "vueUpload" + 0;
      this.$refs[key][0].onFileAdded(files[0]);
    },
    fileGetValue(fileList) { //上传成功的文件
      this.filePathList = fileList;
    },
    fileDelValue(fileList) { //删除的文件
      this.delFilePathList = fileList;
    },
    getTaskDetail() {
      if (this.myTaskState == 1 || this.myTaskState == 2) {
        //执行中
        getTaskSummaryByUserId(this.myTaskId, this.myUserId)
          .then(res => {
            if (res != null && res.DetailList.length > 0) {
              this.editableTabsValue = "0";
              this.FileLists = [];
              this.newFileLists = [];
              this.summaryList.ID = res.ID;
              this.summaryList.DetailList = res.DetailList;
              let key = "";
              let arr = {
                FileList: []
              };
              let hisArr = {
                FileList: []
              };
              key = "wangEdit" + 0;
              this.$refs[key][0].setContent("");
              this.$refs[key][0].setContent(
                this.summaryList.DetailList[0].CONTENT
              );
              for (var i = 0; i < this.summaryList.DetailList.length; i++) {
                if (
                  this.summaryList.DetailList[i].DESCRIPTION != null &&
                  this.summaryList.DetailList[i].DESCRIPTION != ""
                ) {
                  let dd = this.summaryList.DetailList[i].DESCRIPTION.replace(
                    /<\/?.+?>/g,
                    ""
                  );
                  this.summaryList.DetailList[i].DESCRIPTION = dd.replace(
                    / /g,
                    ""
                  ); //dds为得到后的内容
                }
                this.FileLists.push(hisArr);
                this.newFileLists.push(arr);
                this.getHistoryFiles(i, this.summaryList.DetailList[i].ID);
              }
            } else {
              var _this = this;
              this.summaryList = {
                ID: "",
                TASKID: "",
                CREATEUSERID: "",
                CREATEUSERNAME: "",
                CREATEDEPTID: "",
                CREATEDEPTNAME: "",
                CREATETIME: "",
                ISCOMPLETED: false,
                DetailList: [
                  {
                    ID: "",
                    SUMMARYID: "",
                    TITLE: _this.myTaskName,
                    CONTENT: "",
                    DESCRIPTION: _this.myTaskDescreption,
                    SAVEKMS: false,
                    DeviceList: [],
                    OPobjectList: []
                  }
                ]
              };
              this.FileLists = [
                {
                  FileList: []
                }
              ];
              this.newFileLists = [
                {
                  FileList: []
                }
              ];
              let upKey = "uploadFiles" + 0;
              let key = "wangEdit" + 0;
              this.$refs[key][0].setContent("");
              this.$refs[upKey][0].reset();
              this.editableTabsValue = "0";
            }
          })
          .catch(err => {
            console.log("getTaskSummaryByUserId err");
          });
      }
    },
    toSetRowData() {
      this.myTaskId = this.myRowData.taskId;
      this.myUserId = this.myRowData.userId;
      this.myTaskState = this.myRowData.taskState;
      this.isComplete = this.myRowData.Complete;
      this.myTaskName = this.myRowData.taskName;
      this.myTaskDescreption = this.myRowData.taskDescreption;
      this.getTaskDetail();
      this.getWorkRecord("");
    },
    getHistoryFiles(index, ID) {
      GetFileInfoByTaskId(ID, "11")
        .then(res => {
          this.FileLists[index].FileList = res;

          //console.log("文件", res)
        })
        .catch(err => {
          console.log("GetFileInfoByTaskId error");
        });
    },
    getFile(files, cb) {
      this.newFileLists[parseInt(this.editableTabsValue)].FileList = files;
      //console.log(this.newFileLists)
      cb("true");
    },
    onSubmit() {
      this.getWorkRecord(this.workForm.input);
    },
    getWorkRecord(input) {
      this.currentUser = getToken();
      GetAllRecordsByUserID(this.currentUser.userId, input)
        .then(res => {
          this.works = res;
          console.log("记录", res);
        })
        .catch(err => {
          console.log("GetKnowledgeByParam error");
        });
    },
    captureStart() {
      // 截图开始
      cap.StartCapture(this.hideWindow, this);
    },
    exceedUpload(file, fileList) {
      this.$message.warning("最多上传五个文件");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    showKnowledgeDetail(row) {
      //显示知识详情
      this.currentRow = row;
      this.knowledgeDetail = this.currentRow;
      setTimeout(() => {
        this.$refs.refknowledgeDetail.dialogFormVisible = true;
      }, 100);
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentPageChange(val) {
      this.currentPage = val;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    sourceFormatter(row, column) {
      if (row.SOURCE == "0") {
        return "主动添加";
      }
      return "";
    },
    timeFormatter(row, column) {
      return TimeFormat(row.CREATETIME);
    },
    timeFormat(time) {
      return TimeFormat(time);
    },
    idSortmethod(obj1, obj2) {
      var val1 = Number(obj1.INSTANCE);
      var val2 = Number(obj2.INSTANCE);
      return val1 - val2;
    },
    //获取选中的知识
    changeFun(val) {
      this.knowledgeSelData = val;
    },
    getEditChanged(html, text) {
      //富文本编辑器改变时执行
      this.summaryList.DetailList[
        parseInt(this.editableTabsValue)
      ].CONTENT = html;
      console.log("编辑器:", html, this.summaryList);
      this.$emit("getValue", html);
      // 知识库
      this.$emit("SAVEKMS", this.SAVEKMS);
    },
    //知识确定
    sureKnowledgeDia() {
      let key = "wangEdit" + parseInt(this.editableTabsValue);
      //先获取再添加
      let body = this.$refs[key][0].editorContent;
      //console.log(body)
      this.knowledgeSelData.forEach(c => {
        body += c.BODYSTR + "<br/>";
      });
      this.$refs[key][0].setContent(body);
      this.$refs[key][0].editor.change && this.$refs[key][0].editor.change();
      this.resetKnowledge();
      this.knowledgeDialogVisible = false;
    },
    //清空选择知识弹窗
    knowledgeHandleClose(done) {
      this.resetKnowledge();
      done();
    },
    resetKnowledge() {
      this.$refs.searchDetail.$refs.cs1.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs2.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs3.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs4.deleteBtnClick();
      this.$refs.knowledgeTable.clearSelection();
      this.txtSearch = "";
    },
    //知识库搜索
    SearchKnowledge() {
      var para = null;
      let hideOrShowAdvanceSearch =
        this.searchIconState != "el-icon-arrow-down";
      if (hideOrShowAdvanceSearch) {
        para = {
          PageIndex: this.currentPage,
          PageSize: this.pageSize,
          SearchTxt: this.txtSearch,
          Para: this.$refs.searchDetail.searchPara
        };
      } else {
        para = {
          PageIndex: this.currentPage,
          PageSize: this.pageSize,
          SearchTxt: this.txtSearch,
          Para: {
            SortStyle: 1
          }
        };
      }
      GetKnowledgeByParam(para)
        .then(res => {
          this.tableData = res.Items;
          this.totalCount = res.TotalItems;
        })
        .catch(err => {
          console.log("GetKnowledgeByParam error");
        });
    },
    workHandleClose(done) {
      done();
    },
    sureWork(info) {
      let key = "wangEdit" + parseInt(this.editableTabsValue);
      //先获取再添加
      let body = this.summaryList.DetailList[parseInt(this.editableTabsValue)]
        .CONTENT;
      //let body = this.$refs[key][0].editorContent
      body += info + "<br/>";
      this.$refs[key][0].setContent(body);
      this.$refs[key][0].editor.change && this.$refs[key][0].editor.change();
      this.workDialogVisible = false;
    },
    addTab(targetName) {
      this.summaryList.DetailList.push({
        ID: "",
        SUMMARYID: "",
        TITLE: this.myTaskName,
        CONTENT: "",
        DESCRIPTION: this.myTaskDescreption,
        SAVEKMS: "",
        DeviceList: [],
        OPobjectList: []
      });
      this.FileLists.push({
        FileList: []
      });
      this.newFileLists.push({
        FileList: []
      });
      this.editableTabsValue = this.summaryList.DetailList.length - 1 + "";
    },
    removeTab(targetName) {
      if (this.summaryList.DetailList.length > 1) {
        let tabs = this.summaryList.DetailList;
        let hisFiles = this.FileLists;
        let newFiles = this.newFileLists;
        let activeName = parseInt(this.editableTabsValue);
        this.$confirm("删除将无法恢复,是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            for (var i = 0; i < tabs.length; i++) {
              if (i == parseInt(targetName)) {
                hisFiles.splice(i, 1);
                newFiles.splice(i, 1);
                tabs.splice(i, 1);
              }
            }
            if (parseInt(targetName) <= activeName) {
              activeName = activeName - 1;
            }
            this.editableTabsValue = activeName + "";
            this.summaryList.DetailList = tabs;
            this.FileLists = hisFiles;
            this.newFileLists = newFiles;
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    SelKnowledgeObjSetValue(value, callback) {
      GetAllGeneralSelTreeEx()
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            res[i].AggrID =
              res[i].SocialId + "_" + this.GetObjType(res[i].Type);
          }
          callback(res);
        })
        .catch(err => {
          console.log("SelKnowledgeObjSetValue err");
        });
    },
    GetObjType(type) {
      if (
        Linq.from([20, 31, 21, 22, 23]).firstOrDefault(s => s == type) != null
      )
        return 0;
      if (
        Linq.from([24, 25, 29, 12, 14]).firstOrDefault(s => s == type) != null
      )
        return 1;
      if (
        Linq.from([16, 33, 35, 37, 39]).firstOrDefault(s => s == type) != null
      )
        return 3;
      if (
        Linq.from([41, 43, 45, 47, 49]).firstOrDefault(s => s == type) != null
      )
        return 4;
      return -1; //error
    },
    SelKnowledgeObjGetValue(value, callback) {
      let arr = [];
      let obj = {};
      value.forEach(c => {
        obj.TYPE = c.Type;
        obj.DEVICEID = c.SocialId;
        obj.DEVICENAME = c.Name;
        obj.DEVICETYPE = this.GetObjType(c.Type);
        obj.SERIES = c.Serial;
        obj.LOCATION = c.AreaName;
        arr.push(obj);
      });
      this.summaryList.DetailList[
        parseInt(this.editableTabsValue)
      ].DeviceList = arr;
    },
    //选择运维对象产品编码
    SelObjBSMVSetValue(value, callback) {
      GetAllObjTypeBSMV()
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            res[i].AggrID = res[i].SocialId + "_" + "12345";
          }
          callback(res);
        })
        .catch(err => {
          console.log("GetAllObjTypeBSMV err");
        });
    },
    SelObjBSMVGetValue(value, callback) {
      if (value != undefined && value != null) {
        let arr = [];
        let obj = {};
        value.forEach(c => {
          obj.OPOBJECTID = c.SocialId;
          obj.OPOBJECTNAME = c.Name;
          arr.push(obj);
        });
        this.summaryList.DetailList[
          parseInt(this.editableTabsValue)
        ].OPobjectList = arr;
      } else {
      }
    },
    setOftenBSMV(value, callback) {
      GetCommonAndUsedObjTypeBSMV()
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            res[i].AggrID = res[i].SocialId + "_" + "12345";
          }
          callback(res);
        })
        .catch(err => {
          console.log("GetCommonAndUsedObjTypeBSMV err");
        });
    }, //KnowledgeSel  BSMVSel
    addKnowledge() {
      this.$refs.KnowledgeSel.addBtnClick();
    },
    delKnowledge() {
      this.$refs.KnowledgeSel.deleteBtnClick();
    },
    addBSMV() {
      this.$refs.BSMVSel.addBtnClick();
    },
    delBSMV() {
      this.$refs.BSMVSel.deleteBtnClick();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = "小结33";
      if (inputValue) {
        this.dynamicTags.push({
          name: "小结33",
          type: "danger"
        });
      }
    },
    tagClick(key) {
      for (var i = 0; i < this.dynamicTags.length; i++) {
        if (i == key) {
          this.dynamicTags[i].tagHit = true;
        } else {
          this.dynamicTags[i].tagHit = false;
        }
      }
    },
    // 上传
    fileChange(file) {
      if (!file.size) return;
      this.fileList.push(file);

      this.filePanelHeight = {
        height: this.fileList.length * 60 + "px"
      };
      console.log(file);
    },
    onProgress(file, percent) {
      $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
      $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + "%");
    },
    fileUploadCompleted(file, response) {
      console.log("合并" + file.name, response);
      console.log("上传合并", file.name + ":" + response.guid);
      MergeFile(response.guid, response.f_ext).then(data => {
        console.log("合并：", data);
        if (data) {
          this.filePathList.push(data);
          console.log("this.filePathList", this.filePathList);
          this.$emit("upFile", this.filePathList);
        } else {
          this.$message.error("文件合并失败！");
        }
      });
    },
    fileCategory(ext) {
      let type = "";
      const typeMap = {
        image: ["gif", "jpg", "jpeg", "png", "bmp", "webp"],
        video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
        text: [
          "doc",
          "txt",
          "docx",
          "pages",
          "epub",
          "pdf",
          "numbers",
          "csv",
          "xls",
          "xlsx",
          "keynote",
          "ppt",
          "pptx"
        ]
      };
      Object.keys(typeMap).forEach(_type => {
        const extensions = typeMap[_type];
        if (extensions.indexOf(ext) > -1) {
          type = _type;
        }
      });
      return type;
    },
    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    resume(file) {
      this.uploader.upload(file);
    },
    stop(file) {
      this.uploader.stop(file);
    },
    remove(file) {
      // 取消并中断文件上传
      this.uploader.cancelFile(file);
      // 在队列中移除文件
      this.uploader.removeFile(file, true);
      // 在ui上移除
      let index = this.fileList.findIndex(ele => ele.id === file.id);
      this.fileList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.filePanelHeight = {
        height: this.fileList.length * 60 + "px"
      };
    },
    // 上传结束
    SAVEKMSChange(val) {
      console.log(val);
      this.$emit("SAVEKMS", val);
    }
  },
  computed: {}
};
</script>

<style lang="less" scoped>
#myform .el-form-item__label {
  font-size: 16px;
}

#CreateTaskFilePicker {
  font-size: 12px;
  line-height: normal;
}
#myform .el-form-item {
  margin-bottom: 5px;
}

.el-card.is-hover-shadow:hover {
  /*-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);*/
  box-shadow: 0 2px 12px 0 #1000ff8a;
  font-size: 16px;
}

.el-table .warning-row {
  background: #f0f9eb;
}

.el-table .success-row {
  background: #f0f9eb;
}

.myBtn {
  padding: 9px 1px;
}

.toolbar {
  border: 1px solid #ccc;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 5px 25px 5px;
}

.file-panel {
  width: 100%;
  margin-top: 10px;
  box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.1);

  > h2 {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
  }

  .file-list {
    position: relative;
    height: 60px;
    // overflow-y: auto;
    background-color: rgb(250, 250, 250);
  }

  .file-item {
    position: relative;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    z-index: 1;

    > li {
      display: inline-block;
    }
  }

  .file-item li {
    overflow: hidden;
  }

  .file-type {
    width: 24px;
    height: 24px;
    margin-bottom: 18px;
    vertical-align: -5px;
  }

  .file-name {
    width: 30%;
    margin-left: 10px;
  }

  .fileName {
    overflow: hidden;
    /*内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis;
    /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    white-space: nowrap;
    /*不换行 */
  }

  .file-size {
    width: 20%;
  }

  .file-status {
    width: 20%;
  }

  .file-operate {
    width: 20%;

    > a {
      padding: 10px 5px;
      cursor: pointer;
      color: #666;

      &:hover {
        color: #ff4081;
      }
    }
  }

  .file-type[icon="text"] {
    background: url(../../../assets/img/icon/text-icon.png);
  }

  .file-type[icon="video"] {
    background: url(../../../assets/img/icon/video-icon.png);
  }

  .file-type[icon="image"] {
    background: url(../../../assets/img/icon/image-icon.png);
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    width: 0;
    background-color: #e2edfe;
    z-index: -1;
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }
}
</style>
